// extracted by mini-css-extract-plugin
export default {"bulk-edit":"CustomField_bulk-edit__9Qvin"};